import React from 'react';
import PropTypes from 'prop-types';
import Notification from '@tds/core-notification';

import RichText from '../richText';

const Note = ({ type, variant, text, data, options }) => {
  const variantProp = variant && variant !== 'note' ? { variant } : {};
  return (
    <div style={{ margin: '1em 0', width: '100%' }}>
      <Notification {...variantProp}>
        {type === 'richText' ? (
          <RichText data={data} options={options} />
        ) : (
          <p>{text}</p>
        )}
      </Notification>
    </div>
  );
};

Note.propTypes = {
  type: PropTypes.string,
  text: PropTypes.string,
  variant: PropTypes.string,
  data: PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.object).isRequired
  }).isRequired,
  options: PropTypes.shape({
    renderMark: PropTypes.object,
    renderNode: PropTypes.object
  })
};

Note.defaultProps = {
  type: 'text',
  variant: '',
  text: '',
  options: {
    renderMark: {},
    renderNode: {}
  }
};

export default Note;
